/** Authoritative wallet charge. All ledger values remain USD cents. */
/** Public floor and safe fallback for jobs created before dynamic pricing. */
export const MIN_VIDEO_PRICE_CENTS = 190;
